(function() {
    'use strict';

    angular.module('app',['ngSanitize','ngAnimate','chieffancypants.loadingBar','daterangepicker','mm.iban','ngFileUpload','infinite-scroll','ui.bootstrap','ngFileUpload']).config(function($interpolateProvider){
    //$interpolateProvider.startSymbol('{[{').endSymbol('}]}');
	}).config(function($httpProvider,cfpLoadingBarProvider) {
   		// $httpProvider.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';
    	$httpProvider.defaults.headers.post['X-CSRF-Token'] = jQuery('meta[name="csrf-token"]').attr("content");
 	    $httpProvider.defaults.timeout = 30000;
	}).config(["$interpolateProvider",function($interpolateProvider){
        $interpolateProvider.startSymbol("[[");
        $interpolateProvider.endSymbol("]]");
    }]);
})();
 //'ngAnimate' 'ngSanitize'